import React from 'react';
import classNames from 'classnames';

import { MY_TEAM_ATTENDANCE_FILTERS } from 'constants/myTeam';

type AttendanceSummaryField = (typeof MY_TEAM_ATTENDANCE_FILTERS)[keyof typeof MY_TEAM_ATTENDANCE_FILTERS];

interface AttendanceIconProps {
  size?: number;
  color?: string;
}

interface AttendanceSummaryItemProps {
  icon?: React.ComponentType<AttendanceIconProps>;
  size?: number;
  count: number;
  iconColor?: string;
  isVisible?: boolean;
  attendance: string;
  item: AttendanceSummaryField;
}

export function AttendanceSummaryItem(props: Readonly<AttendanceSummaryItemProps>): React.ReactElement | null {
  const { icon: Icon, size = 16, count, iconColor, isVisible = true, attendance, item } = props;

  if (!Icon || !isVisible) {
    return null;
  }

  return (
    <div
      className={classNames('attendance-summary__item d-flex gapx-4 clear-after', {
        [`attendance-summary__item--active-${item}`]: attendance === item,
        // per-category hover tint replaces the generic grey `hover-enabled` one
        [`attendance-summary__item--hover-${item}`]: attendance !== item,
      })}
    >
      <div className="icon d-flex">
        <Icon size={size} color={iconColor} />
      </div>
      <div className="count">{count}</div>
    </div>
  );
}
